import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import {Main} from './presentation/main';
import { setUseApiErrorHandler } from '@zvne/fe-framework/dist/data-access/use-api';
import {handleApiError} from './data-access/reusable/handle-api-error';

setUseApiErrorHandler(handleApiError);

ReactDOM.render(
    <Main/>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
